<style>
	.vm2_wrapper{
    z-index:900 !important;
	}

	.secure{
		-webkit-text-security: disc;
	}
</style> 

<template>
	<span>
		<span v-if="status == 2" class="badge bg-green"><i class="fa fa-check-circle"></i> sikeresen aláírva: {{this.signed_at | moment('YYYY-MM-DD, HH:mm')}}</span>
		<span v-else-if="status == 1" class="badge bg-blue"><i class="fa fa-cog fa-spin"></i> email kiküldve: {{this.notified_at | moment('YYYY-MM-DD, HH:mm')}}</span>
		<span v-else-if="status == 0">
				<button v-if="!hide_email_button" class="btn btn-success mx-1" @click="emailSend"><i class="fa fa-cog fa-spin" v-if="loading"></i> Emailben <i class="fa fa-envelope"></i></button>
				<button v-if="!hide_sign_button" v-b-modal="'signatureModal_'+permit_id" class="btn btn-warning mx-1">Helyben <i class="fa fa-signature"></i></button>
				<span v-if="hide_sign_button && hide_email_button" class="badge bg-red"><i class="fa fa-times"></i> Nem tud aláírni!</span>
		</span>
		<b-modal :id="'signatureModal_'+permit_id" cancel-variant="default" ok-title="Aláírás" cancel-title="Mégse" @ok="sign" @shown="$refs['pininput_'+permit_id].focus()">
			<template slot="modal-header">
				<h4 class="modal-title">Aláírás</h4>
				<a class="btn-close" @click="$bvModal.hide('signatureModal_'+permit_id)"></a>
			</template>
			<Loading v-if="loading" title="Aláírás folyamatban"></Loading>
			<form @submit.prevent="sign()" v-else>
				<label class="form-label">Pin:</label>
				<input class="form-control secure" :ref="'pininput_'+permit_id" maxlength="6" type="text" v-model="pin" required :class="{'is-invalid' : errors.pin}">
				<div class="invalid-feedback d-block" v-if="errors.pin">
					{{ errors.pin[0] }}
				</div>
				<button type="submit" class="d-none"></button>
			</form>
		</b-modal>
	</span>
</template>

<script>
	import Loading from '../components/Loading';
	import Task from "../apis/Task";
export default {
	components: {
		Loading,
	},
	props: {permit_id: Number, signed: String, notified: String, hideEmailButton: Boolean, hideSignButton: Boolean},
	data() {
		return {
			pin:null,
			method:null,
			status: 0,
			errors: [],
			signed_at:"",
			notified_at:"",
			loading:false,
			hide_email_button:false,
			hide_sign_button:false,
		}
	},
	computed: {
		submitObject(){
			return {
				taskpermit_id: this.permit_id,
				pin: this.pin
			}
		}
	},
	created(){
		if(this.notified){
			this.status = 1;
			this.notified_at = this.notified;
		}
		if(this.signed){
			this.status = 2;
			this.signed_at = this.signed;
		}
		if(this.hideEmailButton){
			this.hide_email_button = true;
		}
		if(this.hideSignButton){
			this.hide_sign_button = true;
		}
	},
	watch:{
		signed: function(val){
			if(this.status == 1 && val){
				this.signed_at = val;
				this.status = 2;
			}
		},
		hideEmailButton: function(val){
			this.hide_email_button = val;
		},
		hideSignButton: function(val){
			this.hide_sign_button = val;
		},
	},
	methods:{		
		sign(bvModalEvt){
			this.loading = true;
			if(bvModalEvt){
				bvModalEvt.preventDefault()
			}
			Task.signPermitWithPin(this.submitObject)
			.then(response => {
				this.signed_at = response.data;
				this.status = 2;
				this.$emit('signed',{signed_at:response.data});
				this.$bvModal.hide('signatureModal_'+this.permit_id);
			})
			.catch(error => {
				if(error.response.data.errors){
					this.errors = error.response.data.errors;
				}
			}).finally(() => {
				this.$set(this,'loading',false);
			});
		},
		emailSend(){
			this.loading = true;
			Task.signPermitWithEmail({taskpermit_id: this.permit_id})
			.then(response => {
				this.notified_at = response.data;
				this.status = 1;
			}).finally(() => {
				this.loading = false;
			});
		}
	}
};
</script>
